export default __webpack_public_path__ + "static/media/allagi.932ac908.webp";